import { clearTags, init, setRouteTemplate, setTags } from "@appsignal/browser";

const getMetaContent = (name: string): string | undefined =>
  document.querySelector(`meta[name='${name}']`)?.getAttribute("content") ?? undefined;

const messagelessErrorClasses = new Set<string | undefined>(["SecurityError", "SyntaxError"]);

const ignoredMessages = [/^ResizeObserver loop /u, /^Object Not Found Matching Id:/u];

const apiKey = getMetaContent("appsignal-frontend-api-key");

if (apiKey) {
  init({
    key: apiKey,
    endpoint: "https://appsignal-endpoint.net",
    appVersion: getMetaContent("app-version"),
    beforeError: (event) =>
      (event.error_class === "FetchError" && /: (?:403\b|<no response> )/u.test(event.message)) ||
      (messagelessErrorClasses.has(event.error_class) &&
        /^Uncaught (?:SecurityError|SyntaxError)?$/u.test(event.message)) ||
      ignoredMessages.some((pattern) => pattern.test(event.message))
        ? null
        : event,
  });

  const userId = getMetaContent("user-id");

  if (userId) {
    setTags({ user_id: userId });
  } else {
    clearTags();
  }

  const routeTemplate = getMetaContent("route-template");

  if (routeTemplate) {
    setRouteTemplate(routeTemplate);
  }

  window.addEventListener("phx:route-template", (event) => {
    const { template } = (event as CustomEvent<{ template: string | null }>).detail;

    setRouteTemplate(template);
  });
}
